
import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="main-footer">
      <div className="container">
        <div className="row">
          <div className="col-lg-3 col-md-12">
            <div className="about-footer">
              <div className="footer-logo">
                <img src="/hellotruck-web-images/hello-truck-logo-curved.png" alt="HelloTruck" />
              </div>

              <div className="about-footer-content">
                <p>COVAI HELLO TRUCK PRIVATE LIMITED</p>
                <p style={{fontSize: '14px', color: '#aaa', marginTop: '5px'}}>Reliable. Professional. Hassle-Free Moving Solutions. From start to finish, we're here to make it smooth.</p>
              </div>

              <div className="footer-app-link">
                <a href="https://play.google.com/store/apps/details?id=com.hellotruck.customer&hl=en_IN" target="_blank" rel="noopener noreferrer">
                  <img src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" alt="Get it on Google Play" style={{height: '60px'}} />
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-5">
            <div className="footer-links">
              <h3>quick link</h3>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About us</Link></li>
                <li><Link to="/services">our services</Link></li>
                <li><Link to="/pricing">Latest projects</Link></li>
                <li><Link to="/contact">Contact us</Link></li>
              </ul>
            </div>
          </div>

          <div className="col-lg-3 col-md-7">
            <div className="footer-links">
              <h3>contact us</h3>
              
              <div className="footer-contact-item">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-location.svg" alt="" />
                </div>
                <div className="footer-contact-content">
                  <p>No. 7, Kasthuribai Gandhi Nagar 3rd St, Varadharajapuram, Singanallur, Coimbatore  - 641015</p>
                </div>
              </div>

              <div className="footer-contact-item">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-mail.svg" alt="" />
                </div>
                <div className="footer-contact-content">
                  <p><a href="mailto:support@hellotruck.in">support@hellotruck.in</a></p>
                  <p><a href="mailto:hellotruckcbe@gmail.com">hellotruckcbe@gmail.com</a></p>
                </div>
              </div>

              <div className="footer-contact-item">
                <div className="icon-box">
                  <img src="/hellotruck-web-images/icon-phone.svg" alt="" />
                </div>
                <div className="footer-contact-content">
                  <p><a href="tel:+917053315331">+91 70 5331 5331</a></p>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-3 col-md-12">
            <div className="footer-links footer-newsletter-form">
              <h3>Get in touch</h3>
              <p>Sign up for alerts, our latest blogs, thoughts, and insights</p>
              <form>
                <div className="form-group">
                  <input 
                    type="email" 
                    name="mail" 
                    className="form-control" 
                    placeholder="Enter your email" 
                    required 
                  />
                  <button type="submit" className="btn-default btn-highlighted">subscribe</button>
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-12">
            <div className="footer-copyright">
              <div className="footer-copyright-text">
                <p>Copyright © 2025 COVAI HELLO TRUCK PRIVATE LIMITED. All Rights Reserved. | <Link to="/privacy">Privacy Statement</Link> | <Link to="/terms">Terms & Conditions</Link> | <Link to="/refunds">Refunds & Cancellation</Link></p>
              </div>

              <div className="footer-social-links">
                <ul>
                  <li><a href="https://www.facebook.com/p/Hello-Truck-100090260900695/" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-facebook-f"></i></a></li>
                  <li><a href="https://www.instagram.com/hellotruck.in/#" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram"></i></a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
